<script lang="ts" setup>
import { onMounted, computed, ref, toRefs } from 'vue';
import Dialog from 'primevue/dialog';
import SOWReportingServiceProvider from '@/components/Utilization/SOWReportingServiceProvider.vue';
import TimeRatioReportingServiceProvider from '@/components/Utilization/TimeRatioReportingServiceProvider.vue';
import { EMIT } from '@/enum';
import { useUtilizationStore } from '@/store';
import { ClinicianInterface } from '@/types';

interface TimeUsageModalPropsInterface {
  serviceProvider: ClinicianInterface;
  reportType: string;
  filterDate: Date;
}

const utilizationStore = useUtilizationStore();

const props = defineProps<TimeUsageModalPropsInterface>();

const emit = defineEmits<{
  (eventName: EMIT.CANCEL): void;
}>();

const { serviceProvider, reportType, filterDate } = toRefs(props);

const modalVisible = ref(true);

onMounted(async () => {
  utilizationStore.selectedServiceProviderId = serviceProvider.value.id.toString();
  if (isSOWReport.value) await utilizationStore.updateServiceProviderSOWFilterDate(filterDate.value);
  else await utilizationStore.updateServiceProviderTimeRatioFilterDate(filterDate.value);
});

const isSOWReport = computed<boolean>(() => reportType.value === 'sow');

const headerValue = computed<string>(() => {
  const reportTypeText = reportType.value === 'sow' ? 'SOW Reporting for' : 'Time Ratio Reporting for';
  return `${reportTypeText} ${serviceProvider.value.display_name}`;
});

const cancel = (): void => {
  modalVisible.value = false;
  emit(EMIT.CANCEL);
};
</script>

<template>
  <Dialog
    v-model:visible="modalVisible"
    :header="headerValue"
    :draggable="false"
    :modal="true"
    :style="{ width: '80%' }"
    @hide="cancel"
  >
    <Loader v-if="utilizationStore.loadingServiceProviderData" class="loader loader-height" />
    <SOWReportingServiceProvider v-else-if="isSOWReport" :sow-data="utilizationStore.serviceProviderSOWTableData" />
    <TimeRatioReportingServiceProvider v-else :time-ratio-data="utilizationStore.serviceProviderTimeRatioTableData" />
  </Dialog>
</template>

<style scoped lang="scss">
.loader {
  position: relative;
  top: 50%;
  left: 50%;
  z-index: 50;
  transform: translate(-50%, -50%);
  &.loader-height {
    height: 400px;
  }
}
</style>
